// @ts-strict-ignore
export class PasteArticleInformation {
  public rangeOnLineUsageId: string;
  public pasteOffset: number;
  public count: number;

  public rangeOnLineData: any;
  public offset: number = 0;
  public overlapInfo: any = null;
  public pasteOperation: number;
  public isBuildingBlockPaste: boolean;

  public constructor(rangeOnLineUsageId: string, pasteOffset: number, count: number = 1) {
    this.rangeOnLineUsageId = rangeOnLineUsageId;
    this.pasteOffset = pasteOffset;
    this.count = count;
  }

  public recalculatePasteOffset(): void {
    if (this.rangeOnLineData && this.pasteOperation) {
      this.pasteOffset = this.rangeOnLineData.calculateStartOffset(this.pasteOperation, this.offset, this.overlapInfo, this.isBuildingBlockPaste);
    }
  }
}
